"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var enums_1 = require("../../enums");

var LegalizeSDKError =
/** @class */
function () {
  function LegalizeSDKError(message, details, type) {
    if (type === void 0) {
      type = enums_1.LegalizeSDKErrorType.CLIENT_ERROR;
    }

    this.details = undefined;
    this.message = message;
    this.type = type;
    this.details = details;
    console.log({
      message: message,
      type: type,
      details: details
    });
  }

  return LegalizeSDKError;
}();

exports.default = LegalizeSDKError;